import React, { Component } from 'react';
export class AlreadyFriendPage extends Component {
  constructor(props) {
    super(props);
    this.handleCloseWindow = this.handleCloseWindow.bind(this);
  }

  handleCloseWindow() {
    const { profile } = this.props;
    if (window.opener) {
      if (window.__BROWSER_NAME__ === "Mobile Safari") {
        const open = window.open(',', '_self');
        if (open) {
          open.close();
        } else {
          window.close();
        }
      } else {
         window.close();
      }
    } else {
      location.href = "/" + profile.get('profileId');
    }
  }

  render() {
    const { profile, device } = this.props;
    const { name } = profile;

    const RenderMultiElement = () => [
     <div id="kakaoHead" className="head_bridge" role="banner" key="header">
        <h1 className="tit_logo">
          <a href="#none" className="link_logo" style={{ padding: 0 }}>
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
        </h1>
      </div>,
      <hr className="hide" key="hidden_line" />,
      <div id="kakaoContent" className="cont_bridge" role="main" key="content">
        <div className="innner_bridge inner_bridge2">
          <span className="img_bridge"></span>

          <p className="desc_bridge">{name} 프로필은<br />이미 카카오톡 친구로 추가되어 있습니다.</p>

          <a href="#none" id="cancel_btn" className="btn_bridge" onClick={this.handleCloseWindow}>확인</a>

          <div className="logout_bridge">
            <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
              className="link_logout"
            >
              로그아웃
            </a>
          </div>
        </div>
      </div>
    ];
    return (<RenderMultiElement />);
  }
}

export default AlreadyFriendPage;



// WEBPACK FOOTER //
// ./src/containers/AlreadyFriendPage/index.js